import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Table, Clearfix, Badge, Image } from 'react-bootstrap';
import { withTranslation, Trans } from 'react-i18next';
import {
	fetchWeeklyInfo,
	WEEKLY_INFO_REQUEST, WEEKLY_INFO_SUCCESS, WEEKLY_INFO_FAILURE
} from '../common/actions';
import { loadChildLessonsForDashboard } from '../children/actions';
import { loadChildConsultationsForDashboard } from '../individualConsultations/actions';
import { setPaymentSubGrade, SET_SUBGRADE_REQUEST, SET_SUBGRADE_SUCCESS, SET_SUBGRADE_FAILURE } from '../payments/actions';
import CenterDetailsLink from '../../common/components/CenterDetailsLink';
import ClassDetailsLink from '../../common/components/ClassDetailsLink';
import moment from 'moment';
import utils from '../../common/services/utils';
import { cancelLesson, cancelWorkshopSession } from '../actions';
import { loadChildWorkshopSessionsForDashboard } from '../workshopEnrolments/actions';
import DeleteButton from '../../common/components/DeleteButton';
import FontAwesome from 'react-fontawesome';
import WeeklyInfo from './WeeklyInfo';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import Card from '../../common/components/Card';
import ui from '../../common/services/ui';
import ClassBookingForm from './ClassBookingForm';
import ConsultationBookingForm from './ConsultationBookingForm';
import { selectCenter, selectChild, selectTerm, selectGrade, selectLessonType, unselectLesson, unselectProgramItem } from '../booking/actions';
import BookingsViewSwitch, { BookingView } from './BookingsViewSwitch';
import BookingsLayoutSwitch, { BookingLayout } from './BookingsLayoutSwitch';
import Dialog from '../../common/components/Dialog';

const isMobileView = window.innerWidth < 768;
const defaultLayout = isMobileView ? BookingLayout.GRID : BookingLayout.LIST;

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.loadWeeklyInfo = this.loadWeeklyInfo.bind(this);
		this.handleSubGradeSelect = this.handleSubGradeSelect.bind(this);
		this.switchClassesView = this.switchClassesView.bind(this);
		this.switchConsultationsView = this.switchConsultationsView.bind(this);
		this.switchClassesLayout = this.switchClassesLayout.bind(this);
		this.switchConsultationsLayout = this.switchConsultationsLayout.bind(this);
		this.handleClassBookingSubmit = this.handleClassBookingSubmit.bind(this);
		this.handleConsultationBookingSubmit = this.handleConsultationBookingSubmit.bind(this);
		this.switchWorkshopsView = this.switchWorkshopsView.bind(this);
		this.switchWorkshopsLayout = this.switchWorkshopsLayout.bind(this);
		this.handleWorkshopBookingSubmit = this.handleWorkshopBookingSubmit.bind(this);
		this.showTermsAndConditionsDialog = this.showTermsAndConditionsDialog.bind(this);
		this.hideTermsAndConditionsDialog = this.hideTermsAndConditionsDialog.bind(this);

		this.state = {
			classesViewByChildAndTerm: {},
			consultationsViewByChild: {},
			classesLayoutByChildAndTerm: {},
			consultationsLayoutByChild: {},
			workshopsViewByChild: {},
			workshopsLayoutByChild: {},
			showTermsAndConditions: false
		};
	}

	componentDidMount() {
		this.props.loadChildLessonsForDashboard();
		this.props.loadChildConsultationsForDashboard();
		this.props.loadChildWorkshopSessionsForDashboard();
	}

	handleSubGradeSelect(lesson, grade, onSuccess) {
		this.props.setPaymentSubGrade(lesson.paymentId, grade.id, () => {
			if (onSuccess) {
				onSuccess();
			}
			this.props.loadChildLessonsForDashboard(true);	// update sub-grades for all lessons
		});
	}

	handleClassBookingSubmit({ childId, centerId, termId, gradeId, lessonType }) {
		this.props.selectChildToBook(childId ? Number(childId) : null);
		this.props.selectCenterToBook(centerId ? Number(centerId) : null);
		this.props.selectTermToBook(termId ? Number(termId) : null);
		this.props.selectGradeToBook(gradeId ? Number(gradeId) : null);
		this.props.selectLessonTypeToBook(lessonType || '');

		// reset previously selected class
		this.props.unselectLesson();
		this.props.unselectProgramItem();

		this.props.history.push(centerId ? '/booking/class' : '/booking/center');
	}

	handleConsultationBookingSubmit({ childId, centerId }) {
		if (childId) {
			this.props.selectChildToBook(Number(childId));
		}
		if (centerId) {
			this.props.selectCenterToBook(Number(centerId));
		}
		this.props.history.push('/individual-consultation/booking/class');
	}

	switchClassesView(child, term, newView) {
		const { classesViewByChildAndTerm } = this.state;
		classesViewByChildAndTerm[`${child.id}-${term.id}`] = newView;

		this.setState({
			classesViewByChildAndTerm: { ...classesViewByChildAndTerm }
		});
	}

	switchConsultationsView(child, newView) {
		const { consultationsViewByChild } = this.state;
		consultationsViewByChild[child.id] = newView;

		this.setState({
			consultationsViewByChild: { ...consultationsViewByChild }
		});
	}

	switchClassesLayout(child, term, newLayout) {
		const { classesLayoutByChildAndTerm } = this.state;
		classesLayoutByChildAndTerm[`${child.id}-${term.id}`] = newLayout;

		this.setState({
			classesLayoutByChildAndTerm: { ...classesLayoutByChildAndTerm }
		});
	}

	switchConsultationsLayout(child, newLayout) {
		const { consultationsLayoutByChild } = this.state;
		consultationsLayoutByChild[child.id] = newLayout;

		this.setState({
			consultationsLayoutByChild: { ...consultationsLayoutByChild }
		});
	}

	loadWeeklyInfo(lesson, subGrade) {
		if (lesson) {
			const gradeId = lesson.grade.mixed ? lesson.subGradeId || subGrade.id : lesson.gradeId;
			this.props.fetchWeeklyInfo(gradeId, lesson.weekNumber, lesson.programId, lesson.start);
		}
	}

	renderGroupClassesSectionForChildAndTerm(child, term) {
		const view = this.state.classesViewByChildAndTerm[`${child.id}-${term.id}`] || BookingView.UPCOMING;
		const layout = this.state.classesLayoutByChildAndTerm[`${child.id}-${term.id}`] || defaultLayout;

		const { t, childLessons, centers } = this.props;
		const childLessonsInTerm = childLessons ? childLessons.filter(x => x.childId === child.id && x.termId === term.id) : [];

		const cancelledAndMissedLessons = childLessonsInTerm.filter(x => x.type === 'Normal' && (x.canceled || (!x.isInTheFuture && !x.isAttended)));
		const makeUpCenters = [...new Set(cancelledAndMissedLessons.map(x => x.centerId))]
			.map(id => centers[id])
			.filter(x => x && x.allowMakeUp);

		const childCenters = [...new Set(childLessonsInTerm.map(x => x.centerId))].map(id => centers[id]);

		return <React.Fragment key={child.id}>
			<Row>
				<Col md={8}>
					<span className='pull-right' style={{ marginTop: -5 }}>
						<BookingsLayoutSwitch layout={layout} onSwitch={newLayout => this.switchClassesLayout(child, term, newLayout)} />
					</span>
					<h4>{child.fullName}</h4>
				</Col>
				<Col md={4} style={{ textAlign: 'center' }}>
					<span style={{ marginTop: -5 }}>
						<BookingsViewSwitch view={view} onSwitch={newView => this.switchClassesView(child, term, newView)}
							previousLabel={t('FO_Dashboard_ViewPreviousClasses')} upcomingLabel={t('FO_Dashboard_ViewUpcomingClasses')} />
					</span>
				</Col>
			</Row>
			<Row>
				<Col md={8}>
					{this.renderClassesList(childLessonsInTerm, view, layout)}
				</Col>
				<Col md={4}>
					{this.renderUpcomingClass(childLessonsInTerm)}
					{makeUpCenters.length > 0 && this.renderClassBookingChildShortcut(child, term, 'makeup', makeUpCenters.length === 1 ? makeUpCenters[0].id : null)}
					{this.renderClassBookingChildShortcut(child, term, '', childCenters.length === 1 && childCenters[0] ? childCenters[0].id : null)}
				</Col>
			</Row>
		</React.Fragment>;
	}

	renderClassesList(lessons, view, layout) {
		const { t, centers } = this.props;
		const future = view === BookingView.UPCOMING;

		const filteredLessons = lessons.filter(x => x.isInTheFuture === future);
		if (!filteredLessons || filteredLessons.length === 0) {
			return <div>
				<div style={{ textAlign: 'center', margin: 20 }} className='text-muted'>{t(future ? 'FO_Dashboard_NoUpcomingClasses' : 'FO_Dashboard_NoPreviousClasses')}</div>
			</div>;
		}

		// group by center
		const centerGroups = utils.groupBy(filteredLessons, 'centerId');

		return <React.Fragment>
			{Object.keys(centerGroups).map(key => {
				const center = centers[key];
				const lessons = centerGroups[key];
				const showZoomLinks = future && lessons.some(l => l.zoomUrl);
				const showWeeklyInfo = !future && lessons.some(l => l.hasPaidAccessInTerm);

				let classesList = null;
				const options = { future, showZoomLinks, showWeeklyInfo };
				switch (layout) {
					case BookingLayout.SINGLE:
						classesList = this.renderClassesInSingleLayout(lessons, options);
						break;
					case BookingLayout.GRID:
						classesList = this.renderClassesInGridLayout(lessons, options);
						break;
					case BookingLayout.LIST:
						classesList = this.renderClassesInListLayout(lessons, options);
						break;
				}

				return <div key={key}>
					<h5>
						<span className='pull-right' style={{ textTransform: 'uppercase' }}><CenterDetailsLink center={center} /></span>
						<b>{future ? t('FO_Dashboard_UpcomingClasses') : t('FO_Dashboard_PreviousClasses')}</b>
					</h5>
					{classesList}
				</div>
			})}
		</React.Fragment>
	}

	renderClassesInSingleLayout(lessons, options) {
		const { future, showZoomLinks, showWeeklyInfo } = options;
		const { t } = this.props;
		return <Row>
			{lessons.map(lesson => <Col md={12} key={lesson.id}>
				<Card>
					TODO
				</Card>
			</Col>)}
		</Row>;
	}

	renderClassesInGridLayout(lessons, options) {
		const { showZoomLinks, showWeeklyInfo } = options;
		const { enableUserTimeZone, t } = this.props;

		return <Row>
			{lessons.map(lesson => {
				const lessonStart = enableUserTimeZone ? utils.convertToUserTime(lesson.start, lesson.center) : moment(lesson.start);
				const lessonEnd = enableUserTimeZone ? utils.convertToUserTime(lesson.end, lesson.center) : moment(lesson.end);

				return <Col sm={6} key={lesson.id}>
					<Card color='purple'>
						<div>
							<span className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }}>
								{lesson.grade.imageUrl ? <Image src={lesson.grade.imageUrl} width={35} height={35} /> : <FontAwesome name='users' className='text-purple' />}
							</span>
							<div>
								<h4 style={{ marginBottom: 5 }}>{`${t('FO_Common_Week')} ${lesson.weekNumber}`}</h4>
								<h4 style={{ marginBottom: 5 }} className='text-muted'>{lessonStart.format('dddd L')}</h4>
								<h4 style={{ marginBottom: 5 }} className='text-muted'>{lessonStart.format('LT')} - {lessonEnd.format('LT')}</h4>
							</div>
						</div>
						<div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }} className='grade-link'><ClassDetailsLink programItem={{ id: lesson.programId, centerId: lesson.centerId, name: lesson.name, grade: lesson.grade, term: lesson.term }} /></div>
						{showZoomLinks && <div className='pull-right'>{this.renderZoomUrl(lesson, t('FO_Dashboard_Classes_ZoomUrl'))}</div>}
						{showWeeklyInfo && <div className='pull-right'>{this.renderWeeklyInfo(lesson, t('FO_ChildLesson_ViewWeeklyInfo'))}</div>}
						{this.renderCancelLesson(lesson)}
						{this.renderLessonAttendance(lesson)}
					</Card>
				</Col>
			})}
		</Row>;
	}

	renderClassesInListLayout(lessons, options) {
		const { showZoomLinks, showWeeklyInfo } = options;
		const { enableUserTimeZone, t } = this.props;

		return <Table className='table-expanded' responsive hover>
			<thead>
				<tr>
					<th>{t('FO_Dashboard_Classes_Week')}</th>
					<th>{t('FO_Dashboard_Classes_Day')}</th>
					<th>{t('FO_Dashboard_Classes_Date')}</th>
					<th>{t('FO_Dashboard_Classes_Time')}</th>
					<th>{t('FO_Dashboard_Classes_Grade')}</th>
					{showZoomLinks && <th>{t('FO_Dashboard_Classes_ZoomUrl')}</th>}
					{showWeeklyInfo && <th>{t('FO_Dashboard_Classes_WeeklyInfo')}</th>}
					<th></th>
				</tr>
			</thead>
			<tbody>
				{lessons.map(lesson => {
					const lessonStart = enableUserTimeZone ? utils.convertToUserTime(lesson.start, lesson.center) : moment(lesson.start);
					const lessonEnd = enableUserTimeZone ? utils.convertToUserTime(lesson.end, lesson.center) : moment(lesson.end);

					return <tr key={lesson.id}>
						<td className='purple'>#{lesson.weekNumber}</td>
						<td>{lessonStart.format('dddd')}</td>
						<td>{lessonStart.format('L')}</td>
						<td>{lessonStart.format('LT')} - {lessonEnd.format('LT')}</td>
						<td><ClassDetailsLink programItem={{ id: lesson.programId, centerId: lesson.centerId, name: lesson.name, grade: lesson.grade, term: lesson.term }} /></td>
						{showZoomLinks && <td>{this.renderZoomUrl(lesson)}</td>}
						{showWeeklyInfo && <td>{this.renderWeeklyInfo(lesson, t('FO_Common_View'))}</td>}
						<td>
							{this.renderCancelLesson(lesson)}
							{this.renderLessonAttendance(lesson)}
						</td>
					</tr>
				})}
			</tbody>
		</Table>;
	}

	renderZoomUrl(lesson, text) {
		const { t } = this.props;

		return lesson.zoomUrl && <div>
			<div><a style={{ cursor: 'pointer' }} href={lesson.zoomUrl} target='_blank'>{text || t('FO_ChildLesson_ZoomUrl')}</a></div>
			{lesson.zoomPassword && <div>{t('FO_ChildLesson_ZoomPassword')} {lesson.zoomPassword}</div>}
		</div>;
	}

	renderCancelLesson(lesson) {
		const { enableUserTimeZone, t, cancelLesson } = this.props;

		if (lesson.canceled) {
			return <b className='text-error'>{t('FO_ChildLesson_Canceled')}</b>;
		}

		const lessonStart = enableUserTimeZone ? utils.convertToUserTime(lesson.start, lesson.center) : moment(lesson.start);

		return lesson.isInTheFuture && lesson.allowParentCancelLesson && <DeleteButton onDelete={() => cancelLesson(lesson.id)}
			label={<span className='text-muted'>{t('FO_ChildLesson_CannotAttend')}</span>} hideIcon={true}
			confirmationTitle={t('FO_ChildLesson_CannotAttendConfirmationTitle')}
			confirmationMessage={t('FO_ChildLesson_CannotAttendConfirmationMessage', { lessonDate: lessonStart.format('L') })}
			className='no-decoration'
		/>;
	}

	renderWeeklyInfo(lesson, text) {
		const { t } = this.props;

		return <WeeklyInfo lesson={lesson}
			showInfo={true}
			weeklyInfos={this.props.weeklyInfos}
			onLoadWeeklyInfo={subGrade => this.loadWeeklyInfo(lesson, subGrade)}
			allowSubGradeChange={this.props.userImpersonation}
			grades={this.props.grades}
			onSubGradeSelect={(grade, onSuccess) => this.handleSubGradeSelect(lesson, grade, onSuccess)}
			subGradeBlock={SET_SUBGRADE_REQUEST}
			subGradeUnblock={[SET_SUBGRADE_SUCCESS, SET_SUBGRADE_FAILURE]}
			weeklyInfoBlock={WEEKLY_INFO_REQUEST}
			weeklyInfoUnblock={[WEEKLY_INFO_SUCCESS, WEEKLY_INFO_FAILURE]}
			text={text || t('FO_ChildLesson_ViewWeeklyInfo')}
		/>;
	}

	renderLessonAttendance(lesson) {
		const { t } = this.props;

		return !lesson.isInTheFuture && !lesson.canceled && <b>
			{lesson.isHoliday ? t('FO_ChildLesson_Holiday') :
				lesson.isAttended ? <span className='text-success'>{t('FO_ChildLesson_Attended')}</span> :
					<span className='text-error'>{t('FO_ChildLesson_NotAttended')}</span>}
		</b>;
	}

	renderUpcomingClass(lessons) {
		const { t, enableUserTimeZone } = this.props;
		const firstUpcomingClass = lessons.sort((a, b) => moment(a.start) - moment(b.start)).find(x => x.isInTheFuture && !x.canceled);
		const firstUpcomingClassStart = firstUpcomingClass && (enableUserTimeZone ? utils.convertToUserTime(firstUpcomingClass.start, firstUpcomingClass.center) : moment(firstUpcomingClass.start));

		return firstUpcomingClass && <Card color='purple'>
			<div>
				<FontAwesome name='check' className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }} />
				<div>
					<h4 className='text-success'>{t('FO_Dashboard_NextClassBooked')}</h4>
					<h4 className='text-muted'>{firstUpcomingClassStart.format('LT, L')}</h4>
				</div>
			</div>
			<div style={{ fontSize: 28, marginTop: 10 }}>{firstUpcomingClassStart.format('dddd, LT')}</div>
			<div className='text-muted'>{t('FO_Dashboard_UpcomingClass')}</div>
		</Card>
	}

	showTermsAndConditionsDialog() {
		this.setState({ showTermsAndConditions: true });
	}

	hideTermsAndConditionsDialog() {
		this.setState({ showTermsAndConditions: false });
	}

	renderNewMakeUpBookingInfoLabel(i18nKey) {
		return <span><Trans i18nKey={i18nKey} parent='span'>
			Booking is subject to availability and is valid for this term only <a style={{ cursor: 'pointer' }} onClick={this.showTermsAndConditionsDialog}>T&Cs</a>
		</Trans></span>;
	}

	renderClassBookingChildShortcut(child, term, lessonType = '', centerId = null) {
		const { t } = this.props;

		let titleResource = 'FO_Dashboard_NewClassBooking';
		let textResource = 'FO_Dashboard_NewBooking';
		switch (lessonType) {
			case 'makeup':
				textResource = 'FO_Dashboard_NewMakeUpBooking';
				break;
		}
		const title = t(titleResource);
		const text = t(textResource);

		const showMakeupBookingInfo = lessonType === 'makeup' && t('FO_Dashboard_NewMakeUpBookingInfo');

		return <Card color='purple' title={title} >
			<a onClick={() => this.handleClassBookingSubmit({ childId: child && child.id, termId: term && term.id, lessonType, centerId })} style={{ display: 'block', cursor: 'pointer', textDecoration: 'none' }}>
				<div style={{ fontSize: 28, marginTop: 10 }}>{text}</div>	
				{!showMakeupBookingInfo && this.renderClassBookingIcon()}
			</a>
			{showMakeupBookingInfo && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
				{this.renderNewMakeUpBookingInfoLabel('FO_Dashboard_NewMakeUpBookingInfo')}
				<a onClick={() => this.handleClassBookingSubmit({ childId: child && child.id, termId: term && term.id, lessonType, centerId })} style={{ display: 'block', cursor: 'pointer', textDecoration: 'none' }}>{this.renderClassBookingIcon()}</a>
			</div>}
		</Card>
	}

	renderConsultationsSectionForChild(child) {
		const view = this.state.consultationsViewByChild[child.id] || BookingView.UPCOMING;
		const layout = this.state.consultationsLayoutByChild[child.id] || defaultLayout;

		const { t } = this.props;

		return <React.Fragment key={child.id}>
			<Row>
				<Col md={8}>
					<span className='pull-right' style={{ marginTop: -5 }}>
						<BookingsLayoutSwitch layout={layout} onSwitch={newLayout => this.switchConsultationsLayout(child, newLayout)} />
					</span>
					<h4>{child.fullName}</h4>
				</Col>
				<Col md={4} style={{ textAlign: 'center' }}>
					<span style={{ marginTop: -5 }}>
						<BookingsViewSwitch view={view} onSwitch={newView => this.switchConsultationsView(child, newView)}
							previousLabel={t('FO_Dashboard_ViewPreviousConsultation')} upcomingLabel={t('FO_Dashboard_ViewUpcomingConsultation')} />
					</span>
				</Col>
			</Row>
			<Row>
				<Col md={8}>
					{this.renderConsultationsList(child, view, layout)}
				</Col>
				<Col md={4}>
					{this.renderUpcomingConsultation(child)}
					{this.renderConsultationBookingChildShortcut(child)}
				</Col>
			</Row>
		</React.Fragment>;
	}

	renderConsultationsList(child, view, layout) {
		const { t, consultations, centers } = this.props;
		const future = view === BookingView.UPCOMING;

		const filteredConsultations = consultations && consultations.filter(x => x.childId === child.id && x.isInTheFuture === future);
		if (!filteredConsultations || filteredConsultations.length === 0) {
			return <div>
				<div style={{ textAlign: 'center', margin: 20 }} className='text-muted'>{t(future ? 'FO_Dashboard_NoUpcomingConsultations' : 'FO_Dashboard_NoPreviousConsultations')}</div>
			</div>;
		}

		// group by center
		const centerGroups = utils.groupBy(filteredConsultations, 'centerId');

		return <React.Fragment>
			{Object.keys(centerGroups).map(key => {
				const center = centers[key];
				const centerConsultations = centerGroups[key];

				let consultationsList = null;
				switch (layout) {
					case BookingLayout.SINGLE:
						consultationsList = this.renderConsultationsInSingleLayout(centerConsultations);
						break;
					case BookingLayout.GRID:
						consultationsList = this.renderConsultationsInGridLayout(centerConsultations);
						break;
					case BookingLayout.LIST:
						consultationsList = this.renderConsultationsInListLayout(centerConsultations);
						break;
				}

				return <div key={key}>
					<h5>
						<span className='pull-right' style={{ textTransform: 'uppercase' }}><CenterDetailsLink center={center} /></span>
						<b>{future ? t('FO_Dashboard_UpcomingConsultation') : t('FO_Dashboard_PreviousConsultation')}</b>
					</h5>
					{consultationsList}
				</div>
			})}
		</React.Fragment>
	}

	renderConsultationsInSingleLayout(consultations) {
		const { t } = this.props;

		return <Row>
			{consultations.map(consultation => <Col md={12} id={consultation.id} key={consultation.id}>
				<Card color='green'>
					TODO
				</Card>
			</Col>)}
		</Row>;
	}

	renderConsultationsInGridLayout(consultations) {
		const { enableUserTimeZone, t } = this.props;

		return <Row>
			{consultations.map(consultation => {
				const consultationStart = enableUserTimeZone ? utils.convertToUserTime(consultation.consultationDate, consultation.center) : moment(consultation.consultationDate);
				const consultationEnd = enableUserTimeZone ? utils.convertToUserTime(consultation.consultationEnd, consultation.center) : moment(consultation.consultationEnd);

				return <Col sm={6} id={consultation.id} key={consultation.id}>
					<Card color='green'>
						<div>
							<span className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }}>
								<FontAwesome name='user' className='text-green' />
							</span>
							<div>
								<h4>{consultationStart.format('dddd L')}</h4>
								<h4 className='text-muted'>{consultationStart.format('LT')} - {consultationEnd.format('LT')}</h4>
							</div>
						</div>
						<div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }}>{t(`IndividualConsultationType_${consultation.consultationType}`)}</div>
						<div><Link to={`/individual-consultation/${consultation.id}`}>{t('FO_Common_View')}</Link></div>
					</Card>
				</Col>
			})}
		</Row>;
	}

	renderConsultationsInListLayout(consultations) {
		const { enableUserTimeZone, t } = this.props;

		return <Table className='table-expanded' responsive hover>
			<thead>
				<tr>
					<th>{t('FO_Dashboard_Classes_Day')}</th>
					<th>{t('FO_Dashboard_Classes_Date')}</th>
					<th>{t('FO_Dashboard_Classes_Time')}</th>
					<th>{t('FO_Dashboard_Classes_Type')}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{consultations.map(consultation => {
					const consultationStart = enableUserTimeZone ? utils.convertToUserTime(consultation.consultationDate, consultation.center) : moment(consultation.consultationDate);
					const consultationEnd = enableUserTimeZone ? utils.convertToUserTime(consultation.consultationEnd, consultation.center) : moment(consultation.consultationEnd);

					return <tr key={consultation.id}>
						<td className='green'>{consultationStart.format('dddd')}</td>
						<td>{consultationStart.format('L')}</td>
						<td>{consultationStart.format('LT')} - {consultationEnd.format('LT')}</td>
						<td>{t(`IndividualConsultationType_${consultation.consultationType}`)}</td>
						<td><Link to={`/individual-consultation/${consultation.id}`}>{t('FO_Common_View')}</Link></td>
					</tr>
				})}
			</tbody>
		</Table>;
	}

	//#region Workshops
	handleWorkshopBookingSubmit({ childId, centerId }) {
		if (centerId) {
			this.props.history.push(`/public/workshops?centerId=${centerId}`)
		}
		else {
			this.props.history.push('public/centers', { referrer: 'workshops' });
		}
	}

	switchWorkshopsView(child, newView) {
		const { workshopsViewByChild } = this.state;
		workshopsViewByChild[child.id] = newView;

		this.setState({
			workshopsViewByChild: { ...workshopsViewByChild }
		});
	}

	switchWorkshopsLayout(child, newLayout) {
		const { workshopsLayoutByChild } = this.state;
		workshopsLayoutByChild[child.id] = newLayout;

		this.setState({
			workshopsLayoutByChild: { ...workshopsLayoutByChild }
		});
	}

	renderCancelSession(session) {
		const { t, cancelWorkshopSession, enableUserTimeZone } = this.props;

		if (session.canceled) {
			return <b className='text-error'>{t('FO_ChildLesson_Canceled')}</b>;
		}
		const onSuccess = () => this.props.loadChildWorkshopSessionsForDashboard();
		const sessionStart = enableUserTimeZone ? utils.convertToUserTime(session.start, session.center) : moment(session.start);

		return session.isInTheFuture && session.allowParentCancelWorkshopSession && <DeleteButton onDelete={() => cancelWorkshopSession(session.id, onSuccess)}
			label={<span className='text-muted'>{t('FO_ChildLesson_CannotAttend')}</span>} hideIcon={true}
			confirmationTitle={t('FO_ChildWorkshopSession_CannotAttendConfirmationTitle')}
			confirmationMessage={t('FO_ChildWorkshopSession_CannotAttendConfirmationMessage', { sessionDate: sessionStart.format('L') })}
			className='no-decoration'
		/>;
	}

	renderWorkshopsSectionForChild(child) {
		const view = this.state.workshopsViewByChild[child.id] || BookingView.UPCOMING;
		const layout = this.state.workshopsLayoutByChild[child.id] || defaultLayout;

		const { t } = this.props;

		return <React.Fragment key={child.id}>
			<Row>
				<Col md={8}>
					<span className='pull-right' style={{ marginTop: -5 }}>
						<BookingsLayoutSwitch layout={layout} onSwitch={newLayout => this.switchWorkshopsLayout(child, newLayout)} />
					</span>
					<h4>{child.fullName}</h4>
				</Col>
				<Col md={4} style={{ textAlign: 'center' }}>
					<span style={{ marginTop: -5 }}>
						<BookingsViewSwitch view={view} onSwitch={newView => this.switchWorkshopsView(child, newView)}
							previousLabel={t('FO_Dashboard_ViewPreviousWorkshops')} upcomingLabel={t('FO_Dashboard_ViewUpcomingWorkshops')} />
					</span>
				</Col>
			</Row>
			<Row>
				<Col md={8}>
					{this.renderWorkshopsList(child, view, layout)}
				</Col>
				<Col md={4}>
					{this.renderUpcomingWorkshops(child)}
					{this.renderWorkshopBookingChildShortcut(child)}
				</Col>
			</Row>
		</React.Fragment>;
	}

	renderWorkshopsList(child, view, layout) {
		const { t, workshopSessions, centers } = this.props;
		const future = view === BookingView.UPCOMING;

		const filteredWorkshopSessions = workshopSessions && workshopSessions.filter(x => x.childId === child.id && x.isInTheFuture === future);
		if (!filteredWorkshopSessions || filteredWorkshopSessions.length === 0) {
			return <div>
				<div style={{ textAlign: 'center', margin: 20 }} className='text-muted'>{t(future ? 'FO_Dashboard_NoUpcomingWorkshops' : 'FO_Dashboard_NoPreviousWorkshops')}</div>
			</div>;
		}

		// group by center
		const centerGroups = utils.groupBy(filteredWorkshopSessions, 'centerId');

		return <React.Fragment>
			{Object.keys(centerGroups).map(key => {
				const center = centers[key];
				const centerWorkshopSessions = centerGroups[key];

				let workshopSessionsList = null;
				switch (layout) {
					case BookingLayout.SINGLE:
						workshopSessionsList = this.renderWorkshopsInSingleLayout(centerWorkshopSessions);
						break;
					case BookingLayout.GRID:
						workshopSessionsList = this.renderWorkshopsInGridLayout(centerWorkshopSessions);
						break;
					case BookingLayout.LIST:
						workshopSessionsList = this.renderWorkshopsInListLayout(centerWorkshopSessions);
						break;
				}

				return <div key={key}>
					<h5>
						<span className='pull-right' style={{ textTransform: 'uppercase' }}><CenterDetailsLink center={center} /></span>
						<b>{future ? t('FO_Dashboard_UpcomingWorkshops') : t('FO_Dashboard_PreviousWorkshops')}</b>
					</h5>
					{workshopSessionsList}
				</div>
			})}
		</React.Fragment>
	}

	renderWorkshopsInSingleLayout(workshopSessions) {
		return <Row>
			{workshopSessions.map(workshopSession => <Col md={12} id={workshopSession.id} key={workshopSession.id}>
				<Card color='orange'>
					TODO
				</Card>
			</Col>)}
		</Row>;
	}

	renderWorkshopsInGridLayout(workshopSessions) {
		const { enableUserTimeZone, t } = this.props;

		return <Row>
			{workshopSessions.map(workshopSession => {
				const sessionStart = enableUserTimeZone ? utils.convertToUserTime(workshopSession.start, workshopSession.center) : moment(workshopSession.start);
				const sessionEnd = enableUserTimeZone ? utils.convertToUserTime(workshopSession.end, workshopSession.center) : moment(workshopSession.end);

				return <Col sm={6} id={workshopSession.id} key={workshopSession.id}>
					<Card color='orange'>
						<div>
							<span className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }}>
								<FontAwesome name='user' className='text-green' />
							</span>
							<div>
								<h4 style={{ marginBottom: 5 }}>{workshopSession.week}</h4>
								<h4 style={{ marginBottom: 5 }} className='text-muted'>{sessionStart.format('dddd L')}</h4>
								<h4 style={{ marginBottom: 5 }} className='text-muted'>{sessionStart.format('LT')} - {sessionEnd.format('LT')}</h4>
							</div>
						</div>
						<div style={{ fontSize: 20, marginTop: 10, marginBottom: 10 }}>{workshopSession.workshop}</div>
						{this.renderCancelSession(workshopSession)}
						{this.renderLessonAttendance(workshopSession)}
					</Card>
				</Col>
			})}
		</Row>;
	}

	renderWorkshopsInListLayout(workshopSessions) {
		const { enableUserTimeZone, t } = this.props;

		return <Table className='table-expanded' responsive hover>
			<thead>
				<tr>
					<th>{t('FO_Dashboard_Classes_Day')}</th>
					<th>{t('FO_Dashboard_Classes_Date')}</th>
					<th>{t('FO_Dashboard_Classes_Time')}</th>
					<th>{t('FO_Dashboard_WorkshopSession_Workshop')}</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{workshopSessions.map(workshopSession => {
					const sessionStart = enableUserTimeZone ? utils.convertToUserTime(workshopSession.start, workshopSession.center) : moment(workshopSession.start);
					const sessionEnd = enableUserTimeZone ? utils.convertToUserTime(workshopSession.end, workshopSession.center) : moment(workshopSession.end);

					return <tr key={workshopSession.id}>
						<td className='orange'>{sessionStart.format('dddd')}</td>
						<td>{sessionStart.format('L')}</td>
						<td>{sessionStart.format('LT')} - {sessionEnd.format('LT')}</td>
						<td>{workshopSession.workshop} - {workshopSession.week}</td>
						<td>
							{this.renderCancelSession(workshopSession)}
							{this.renderLessonAttendance(workshopSession)}
						</td>
					</tr>
				})}
			</tbody>
		</Table>;
	}

	renderUpcomingWorkshops(child) {
		const { t, workshopSessions, enableUserTimeZone } = this.props;
		const firstUpcomingSession = workshopSessions && workshopSessions.sort((a, b) => moment(a.start) - moment(b.start)).find(x => x.childId === child.id && x.isInTheFuture);
		const firstUpcomingSessionStart = firstUpcomingSession && (enableUserTimeZone ? utils.convertToUserTime(firstUpcomingSession.start, firstUpcomingSession.center) : moment(firstUpcomingSession.start));

		return firstUpcomingSession && <Card color='orange'>
			<div>
				<FontAwesome name='check' className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }} />
				<div>
					<h4 className='text-success'>{t('FO_Dashboard_NextWorkshopSessionBooked')}</h4>
					<h4 className='text-muted'>{firstUpcomingSessionStart.format('LT, L')}</h4>
				</div>
			</div>
			<div style={{ fontSize: 28, marginTop: 10 }}>{firstUpcomingSessionStart.format('dddd, LT')}</div>
			<div className='text-muted'>{t('FO_Dashboard_UpcomingWorkshopSession')}</div>
		</Card>
	}

	renderWorkshopBookingChildShortcut(child) {
		const { t } = this.props;

		return <Card color='orange' title={t('FO_Dashboard_NewWorkshopBooking')}>
			<a onClick={() => this.handleWorkshopBookingSubmit({ childId: child && child.id })} style={{ display: 'block', cursor: 'pointer', textDecoration: 'none' }}>
				<div style={{ fontSize: 28, marginTop: 10 }}>{t('FO_Dashboard_NewWorkshop')}</div>
				{this.renderClassBookingIcon()}
			</a>
		</Card>
	}

	renderWorkshopBookingShortcut(height, minHeight) {
		const { t } = this.props;

		return <Card color='green' title={t('FO_Dashboard_NewWorkshopBooking')} >
			<a onClick={() => this.handleWorkshopBookingSubmit({})} style={{ display: 'block', cursor: 'pointer', textDecoration: 'none' }}>
				<div style={{ height: height, minHeight: minHeight }}>
					<div style={{ fontSize: 28, marginTop: 10 }}>{t('FO_Dashboard_NewWorkshop')}</div>
					<div style={{ marginTop: height > minHeight ? height - minHeight : 0 }}>
						{this.renderClassBookingIcon()}
					</div>
				</div>
			</a>
		</Card>
	}

	//#endregion

	renderClassBookingShortcut(height, minHeight) {
		const { t } = this.props;

		return <Card color='purple' title={t('FO_Dashboard_NewClassBooking')}>
			<a onClick={() => this.handleClassBookingSubmit({})} style={{ display: 'block', cursor: 'pointer', textDecoration: 'none' }}>
				<div style={{ height: height, minHeight: minHeight }}>
					<div style={{ fontSize: 28, marginTop: 10 }}>{t('FO_Dashboard_NewBooking')}</div>
					<div style={{ marginTop: height > minHeight ? height - minHeight : 0 }}>
						{this.renderClassBookingIcon()}
					</div>
				</div>
			</a>
		</Card>
	}

	renderClassBookingIcon() {
		const iconStyle = {
			float: 'right',
			width: 55, height: 55, lineHeight: '56px', fontSize: 22,
		};

		return <span><FontAwesome name='plus' className='btn-primary circle-icon' style={iconStyle} /></span>;
	}

	renderBookingForms() {
		const { t, centerId, children, centers, terms, grades, hasConsultation } = this.props;

		const centerEntities = Object.values(centers);
		const consultationCenterEntities = centerEntities.filter(x => x.isIndividualConsultation);
		const termEntities = Object.values(terms).filter(x => x.allowBooking);
		const gradeEntities = Object.values(grades);

		const initialValuesClass = {
			childId: children.length && children[0].id,
			centerId: centerId && centers[centerId] ? centerId : (centerEntities.length && centerEntities[0].id),
			termId: termEntities.length && termEntities[0].id,
			gradeId: gradeEntities.length && gradeEntities[0].id
		};

		const initialValuesConsultation = {
			childId: children.length && children[0].id,
			centerId: centerId && consultationCenterEntities.find(x => x.id === centerId) ? centerId : (consultationCenterEntities.length && consultationCenterEntities[0].id),
		};

		return <React.Fragment>
			<Col md={6}>
				<Card color='purple' title={t('FO_Dashboard_NewClassBooking')}>
					<ClassBookingForm onSubmit={this.handleClassBookingSubmit} initialValues={initialValuesClass}
						children={children}
						centers={centerEntities}
						terms={termEntities}
						grades={gradeEntities}
					/>
				</Card>
			</Col>
			{
				hasConsultation && <Col md={6}>
					<Card color='green' title={t('FO_Dashboard_NewConsultationBooking')}>
						<ConsultationBookingForm onSubmit={this.handleConsultationBookingSubmit} initialValues={initialValuesConsultation}
							children={children}
							centers={consultationCenterEntities}
						/>
					</Card>
				</Col>
			}
		</React.Fragment>;
	}

	renderUpcomingConsultation(child) {
		const { t, consultations, enableUserTimeZone } = this.props;
		const firstUpcomingConsultation = consultations && consultations.sort((a, b) => moment(a.consultationDate) - moment(b.consultationDate)).find(x => x.childId === child.id && x.isInTheFuture);
		const firstUpcomingConsultationStart = firstUpcomingConsultation && (enableUserTimeZone ? utils.convertToUserTime(firstUpcomingConsultation.consultationDate, firstUpcomingConsultation.center) : moment(firstUpcomingConsultation.consultationDate));

		return firstUpcomingConsultation && <Card color='green'>
			<div>
				<FontAwesome name='check' className='circle-icon bg-light' style={{ float: 'left', marginRight: 8, marginTop: -5, width: 55, height: 55, lineHeight: '55px', fontSize: 24 }} />
				<div>
					<h4 className='text-success'>{t('FO_Dashboard_NextConsultationBooked')}</h4>
					<h4 className='text-muted'>{firstUpcomingConsultationStart.format('LT, L')}</h4>
				</div>
			</div>
			<div style={{ fontSize: 28, marginTop: 10 }}>{firstUpcomingConsultationStart.format('dddd, LT')}</div>
			<div className='text-muted'>{t('FO_Dashboard_UpcomingConsultation')}</div>
		</Card>
	}

	renderConsultationBookingChildShortcut(child) {
		const { t } = this.props;

		return <Card color='green' title={t('FO_Dashboard_NewConsultationBooking')}>
			<a onClick={() => this.handleConsultationBookingSubmit({ childId: child && child.id })} style={{ display: 'block', cursor: 'pointer', textDecoration: 'none' }}>
				<div style={{ fontSize: 28, marginTop: 10 }}>{t('FO_Dashboard_NewConsultation')}</div>
				{this.renderConsultationBookingIcon()}
			</a>
		</Card>
	}

	renderConsultationBookingShortcut(height, minHeight) {
		const { t } = this.props;

		return <Card color='green' title={t('FO_Dashboard_NewConsultationBooking')} >
			<a onClick={() => this.handleConsultationBookingSubmit({})} style={{ display: 'block', cursor: 'pointer', textDecoration: 'none' }}>
				<div style={{ height: height, minHeight: minHeight }}>
					<div style={{ fontSize: 28, marginTop: 10 }}>{t('FO_Dashboard_NewConsultation')}</div>
					<div style={{ marginTop: height > minHeight ? height - minHeight : 0 }}>
						{this.renderConsultationBookingIcon()}
					</div>
				</div>
			</a>
		</Card>
	}

	renderConsultationBookingIcon() {
		const iconStyle = {
			float: 'right',
			width: 55, height: 55, lineHeight: '56px', fontSize: 22,
		};

		return <span> <FontAwesome name='plus' className='btn-primary circle-icon' style={iconStyle} /> </span>;
	}

	renderAddChildLink(t) {
		return <div style={{ marginTop: 30, textAlign: 'center' }}>
			<div> <span>{t('FO_Dashboard_NoChildren')}</span></div>
			<div style={{ marginTop: 10 }}> <Link to={'/booking/child?add=true&reset=true'}>{t('FO_Dashboard_AddChild')}</Link></div>
		</div>;
	}

	render() {
		const {
			t, terms, children,
			childLessons, childLessonsLoading,
			hasConsultation,
			hasWorkshops,
			consultations, consultationsLoading,
			workshopSessions, workshopsLoading,
			franchisor
		} = this.props;

		const bookedTerms = [...new Set(childLessons.map(x => x.termId))].map(id => terms[id]).filter(x => x);

		const bookedChildren = [...new Set(childLessons.map(x => x.childId))].map(id => children.find(x => x.id === id)).filter(x => x);
		const consultationChildren = [...new Set(consultations.map(x => x.childId))].map(id => children.find(x => x.id === id)).filter(x => x);
		const workshopChildren = [...new Set(workshopSessions.map(x => x.childId))].map(id => children.find(x => x.id === id)).filter(x => x);

		const noResults = <div style={{ textAlign: 'center' }} className='text-muted'>{t('FO_Common_NoResults')}</div>;

		const avatarStyle = { float: 'left', marginRight: 8, marginTop: -5, width: 45, height: 45, lineHeight: '45px', fontSize: 18 };
		const avatarColors = ['bg-purple', 'bg-green', 'bg-orange', 'bg-blue'];

		const maxChildrenCount = bookedChildren.length > consultationChildren.length ? bookedChildren.length : consultationChildren.length;
		const childrenCardHeght = (maxChildrenCount > 3 ? 3 : maxChildrenCount) * 55;
		const childrenCardMinHeght = 92;
		const hideChildrenCards = hasConsultation && bookedChildren.length == 0 && consultationChildren.length == 0;

		return (<div>
			<h3>{t('FO_Dashboard_Overview')}</h3>
			<Clearfix />
			<Row>
				{!hideChildrenCards && <Col md={6}>
					<Card color='purple' title={<span>{t('FO_Dashboard_BookedChildren')} <Badge className='badge-purple'>{bookedChildren.length}</Badge></span>}>
						<div style={{ height: childrenCardHeght, minHeight: childrenCardMinHeght, overflow: 'auto' }}>
							<BlockUi blocking={childLessonsLoading}>
								{bookedChildren && bookedChildren.map(child => (child && <div style={{ marginTop: 15 }} key={child.id}>
									<div className={`circle-icon text-white ${avatarColors[child.id % avatarColors.length]}`} style={avatarStyle}>{ui.getAvatarName(child.firstName, child.lastName)}</div>
									<div>
										<div>
											<b>{child.fullName}</b><b className=''></b>
											<b className='pull-right'>{childLessons.filter(x => x.childId === child.id && x.isInTheFuture && !x.canceled).length}</b>
										</div>
										<div className='text-muted'>
											<span>{t('FO_Dashboard_YearsOld', { age: child.age })}</span>
											<span className='pull-right'>{t('FO_Dashboard_UpcomingClasses')}</span>
										</div>
									</div>
									<Clearfix />
								</div>))}
								{children.length == 0 && this.renderAddChildLink(t)}
							</BlockUi>
						</div>
					</Card>
				</Col>}
				{!hideChildrenCards && hasConsultation && <Col md={6}>
					<Card color='green' title={<span>{t('FO_Dashboard_BookedConsultationChildren')} <Badge className='badge-green'>{consultationChildren.length}</Badge></span>}>
						<div style={{ height: childrenCardHeght, minHeight: childrenCardMinHeght, overflow: 'auto' }}>
							<BlockUi blocking={consultationsLoading}>
								{consultationChildren.map(child => <div style={{ marginTop: 15 }} key={child.id}>
									<div className={`circle-icon text-white ${avatarColors[child.id % avatarColors.length]}`} style={avatarStyle}>{ui.getAvatarName(child.firstName, child.lastName)}</div>
									<div>
										<div>
											<b>{child.fullName}</b><b className=''></b>
											<b className='pull-right'>{consultations.filter(x => x.childId === child.id && x.isInTheFuture).length}</b>
										</div>
										<div className='text-muted'>
											<span>{t('FO_Dashboard_YearsOld', { age: child.age })}</span>
											<span className='pull-right'>{t('FO_Dashboard_UpcomingConsultations')}</span>
										</div>
									</div>
									<Clearfix />
								</div>)}
								{children.length == 0 && this.renderAddChildLink(t)}
							</BlockUi>
						</div>
					</Card>
				</Col>}
				<Col md={6}>
					{this.renderClassBookingShortcut(hasConsultation ? childrenCardMinHeght : childrenCardHeght, childrenCardMinHeght)}
				</Col>
				{hasConsultation && <Col md={6}>
					{this.renderConsultationBookingShortcut(childrenCardMinHeght, childrenCardMinHeght)}
				</Col>}
			</Row>
			<BlockUi blocking={childLessonsLoading}>
				{bookedTerms.length === 0 ? <React.Fragment><h3>{t('FO_Dashboard_Classes')}</h3>{noResults}</React.Fragment> :
					bookedTerms.map(term => {
						const bookedChildrenInTerm = [...new Set(childLessons.filter(x => x.termId === term.id).map(x => x.childId))].map(id => children.find(x => x.id === id)).filter(x => x);
						return <React.Fragment><h3>{t('FO_Dashboard_Classes')} - {term.name}</h3>
							{bookedChildrenInTerm.length === 0 ? noResults :
								bookedChildrenInTerm.map(child => child && this.renderGroupClassesSectionForChildAndTerm(child, term))}
						</React.Fragment>;
					})}
			</BlockUi>

			{hasConsultation && <BlockUi blocking={consultationsLoading}>
				<h3>{t('FO_Dashboard_Consultation')}</h3>
				{consultationChildren.length === 0 ? noResults :
					consultationChildren.map(child => child && this.renderConsultationsSectionForChild(child))}
			</BlockUi>}
			{hasWorkshops && <BlockUi blocking={workshopsLoading}>
				<h3>{t('FO_Dashboard_Workshops')}</h3>
				{workshopChildren.length === 0 ? noResults :
					workshopChildren.map(child => child && this.renderWorkshopsSectionForChild(child))}
			</BlockUi>}
			<Dialog show={this.state.showTermsAndConditions} onHide={this.hideTermsAndConditionsDialog} header={t('FO_Register_TermsAndConditionsTitle')}
				body={<div dangerouslySetInnerHTML={{ __html: franchisor.termsAndConditions }} />} bsSize='large' />
		</div >);
	}
}

const mapStateToProps = state => {
	const { parent, entities: { centers, grades, terms, childLessons, weeklyInfos, individualConsultationsDashboard, workshopSessionsDashboard }, filters, auth: { currentUser }, configuration: { franchisor } } = state;

	const dashboardLessonsFilter = filters.childLessonsForDashboard.all || { ids: [], loading: false };
	const dashboardLessons = dashboardLessonsFilter.ids.map(id => childLessons[id]);
	dashboardLessons.forEach(lesson => {
		lesson.center = centers[lesson.centerId] || { name: '' };
		lesson.grade = grades[lesson.gradeId] || { name: '', subGrades: [] };
		lesson.subGrade = lesson.subGradeId && grades[lesson.subGradeId];
	});

	const consultationsForDashboardFilter = filters.childConsultationsForDashboard.all || { ids: [], loading: false };
	const consultationsForDashboard = consultationsForDashboardFilter.ids.map(id => individualConsultationsDashboard[id]);
	consultationsForDashboard.forEach(consultation => {
		consultation.center = centers[consultation.centerId] || { name: '' };
	});

	const workshopsForDashboardFilter = filters.childWorkshopSessionsForDashboard.all || { ids: [], loading: false };
	const workshopsForDashboard = workshopsForDashboardFilter.ids.map(id => workshopSessionsDashboard[id]);
	workshopsForDashboard.forEach(workshop => {
		workshop.center = centers[workshop.centerId] || { name: '' };
	});

	return {
		...parent,
		childLessons: dashboardLessons,
		childLessonsLoading: dashboardLessonsFilter.loading,
		terms,
		centers,
		grades,
		weeklyInfos,
		userImpersonation: currentUser.userImpersonation,
		franchisor,
		consultations: consultationsForDashboard,
		consultationsLoading: consultationsForDashboardFilter.loading,
		hasConsultation: centers && Object.values(centers).some(x => x.isIndividualConsultation),
		hasWorkshops: franchisor.enableWorkshops && centers && Object.values(centers).some(x => x.isWorkshops),
		workshopSessions: workshopsForDashboard,
		workshopsLoading: workshopsForDashboardFilter.loading,
		enableUserTimeZone: franchisor && franchisor.enableUserTimeZone
	};
};

export default connect(mapStateToProps, {
	loadChildLessonsForDashboard,
	loadChildConsultationsForDashboard,
	loadChildWorkshopSessionsForDashboard,
	cancelLesson,
	fetchWeeklyInfo,
	setPaymentSubGrade,
	selectChildToBook: selectChild,
	selectCenterToBook: selectCenter,
	selectTermToBook: selectTerm,
	selectGradeToBook: selectGrade,
	selectLessonTypeToBook: selectLessonType,
	unselectLesson,
	unselectProgramItem,
	cancelWorkshopSession
})(withTranslation()(Dashboard));